import { TreeSelect } from '@/components/TreeSelect';
import { TreeNodeLike } from '@/components/TreeSelect/useTreeSelect/types';
import { Typography } from '@analytical-alley/ui';

interface ChannelsStepProps {
    medias: TreeNodeLike[];
    mediasWithDisabled: (TreeNodeLike & { selected: boolean })[];
    disabledChannels: string[];
    onCheckedChange: (checkedNodes: TreeNodeLike[]) => void;
}

export const ChannelsStep = ({
    medias,
    mediasWithDisabled,
    disabledChannels,
    onCheckedChange,
}: ChannelsStepProps) => {
    return (
        <div className="[&>button]:w-full">
            <Typography variant="bodyS" className="mb-3 text-gray-500">
                Pick the media channels to include in this campaign. <br />
                Any unselected channels are excluded from the optimisation and
                receive no budget allocation.
            </Typography>
            <TreeSelect
                dataNodes={mediasWithDisabled}
                compact
                className="z-50 w-full"
                label={
                    disabledChannels.length === 0
                        ? `All channels (${medias.length})`
                        : `${medias.length - disabledChannels.length} of ${medias.length} channels`
                }
                onCheckedChange={onCheckedChange}
            />
        </div>
    );
};
